import asyncAppend from '@elements/async-append';
import {onFind, initInScope} from "@elements/init-modules-in-scope";
import * as formValidation from '@elements/form-validation';

import {
    findAllIn,
    addClass,
    hasClass,
    findIn,
    on,
    off,
    trigger,
    setAttribute,
    removeAttribute,
    closest
} from "@elements/dom-utils";
import {matches} from "@elements/dom-utils";

const defaultSelectors = {
    base: '.js-personalization-form',
    teaserResults: '.js-personalization-form__teaser-result',
    checkoutResults: '.js-personalization-form__checkout-result',
    checkoutDetailResults: '.js-personalization-form__checkout-detail-result',
    failedFormResults: '.js-personalization-form__failed-form-result',
    fileInput: '.js-personalization-form__file-input',
    loading: '.js-personalization-form__loading',
    notifications: '.js-personalization-form__notifications',
    form: '.js-personalization-form__form',
    errorArea: '.js-personalization-form__error-area',
    finalLink: '.js-personalization-form__final-link',
    teaser: '.js-personalization-form__teaser',
    teaserWrapper: '.js-personalization-form__teaser-wrapper',
    teaserButton: '.js-personalization-form__teaser-btn',
    teaserButtonIcon: '.js-personalization-form__teaser-btn-icon',
    teaserError: '.js-personalization-form__teaser-error',
    selectPerson: '.js-personalization-form__select-person',
    selectPersonResult: '.js-personalization-form__select-person-result'
};

const defaultOptions = {
    fetchHeaders: {}
};


export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createPersonalizationForm(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createPersonalizationForm(baseElement, options = defaultOptions, selectors = defaultSelectors) {
    let checkoutResults = findAllIn(selectors.checkoutResults, baseElement);
    let teaserResults = findAllIn(selectors.teaserResults, baseElement);
    let checkoutDetailResults = findAllIn(selectors.checkoutDetailResults, baseElement);

    let notifications = findAllIn(selectors.notifications, baseElement);
    let errorAreas = findAllIn(selectors.errorArea, baseElement);

    //datepicker fix for year-input in modal
    document.addEventListener('focusin', (e) => {
        if (e.target.closest(".flatpickr-calendar") !== null) {
            e.stopImmediatePropagation();
        }
    });

    // check if all teasers are personalized
    // mark teasers which are not personalized
    onFind(selectors.finalLink, function(finalLink) {
        on('click', function(evt) {
            let personalizationTeasers = findAllIn(selectors.teaser, baseElement).filter(el => !hasClass('personalization-teaser--personalized', el));
            let personalizationTeasersWrapper = findAllIn(selectors.teaserWrapper, baseElement).filter(el => !hasClass('personalization-teaser-wrapper--personalized', el));

            if (personalizationTeasers.length > 0) {
                evt.preventDefault();
                personalizationTeasers.map(item => addClass('personalization-teaser--failed', item));
                personalizationTeasersWrapper
                    .map(findIn(selectors.teaserError))
                    .filter(x => !!x)
                    .map(removeAttribute('hidden'))

                personalizationTeasers.map(function(item) {
                    addClass('personalization-teaser--failed', item);
                    let buttonText = findIn(selectors.teaserButton, item);
                    let icon = findIn(selectors.teaserButtonIcon, item);
                    if (buttonText) {
                        buttonText.innerText = buttonText.dataset.personalizationErrorText;
                        closest('button', buttonText).classList.remove('btn-dark');
                        closest('button', buttonText).classList.add('btn-danger');
                    }
                    if (icon) {
                        icon.classList.remove('icon-user');
                        icon.classList.add(icon.dataset.personalizationErrorIcon);
                    }
                });

                scrollToTarget(personalizationTeasers[0], 100);
            }
        }, finalLink)
    });


    onFind(selectors.form, function (form) {
      
        let loadingElements = findAllIn(selectors.loading, baseElement);

        const submitHandler = evt => {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            submitForm(form, loadingElements);
        };

        on('form-validation.submit', (evt) => {
            console.log("SUBMIT FORM VALIDATION", evt);
            submitHandler(evt);
        }, form);

        return () => {
            off('submit', submitHandler, form);
        }
    }, baseElement);

    onFind(selectors.selectPerson, function (select) {
        on('change', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();

            let action = evt.target.options[evt.target.selectedIndex].getAttribute("data-personalization-form-select-person-url");
            let closestForm = closest(selectors.form, select);
            let target = findIn(selectors.selectPersonResult, closestForm);
            let loadingElements = findAllIn(selectors.loading, closestForm);
            let pendingRequest = null;

            pendingRequest = fetch(action, {
                method: 'POST',
                body: {
                    person: evt.target.value
                },
                headers: {}
            });

            asyncAppend(
                {
                    target: target,
                    loading: loadingElements,
                    notifications: notifications,
                    options: {
                        allowScriptTags: true,
                    }
                },
                pendingRequest
            )
                .then((result) => {
                    let modal = closest('.modal', closestForm)
                    initInScope(modal);
                })
                .catch(() => {
                });

        }, select);
    });

    function submitForm(form, loadingElements) {
        console.log("SUBMIT FORM");
        let failedFormResults = findAllIn(selectors.failedFormResults, baseElement);


        let action = form.dataset.action || form.getAttribute('action');
        let params = new FormData(form);

        let request = null;
        request = fetch(action, {
            method: 'POST',
            body: params,
            headers: {}
        });

        console.log(request);

        asyncAppend(
            {
                target: {
                    "teaser-result": teaserResults,
                    "checkout-footer-top": checkoutResults,
                    "checkout-footer-bottom": checkoutDetailResults,
                    "failed-form-result": failedFormResults
                },
                loading: loadingElements,
                notifications: notifications,
                options: {
                    allowScriptTags: true,
                }
            },
            request
        )
            .then((result) => {
                let content = result.html || result.content;
                if (content && result.success !== false) {
                    console.log("CLOSE NOW");
                    let modal = closest('.modal', form);
                    if (modal && !result.content['failed-form-result']) {
                        let modalToClose = findIn('.js-modal-close', modal);
                        trigger('click', modalToClose);

                        console.log(modalToClose);
                        if (result['__trackingScript']) {
                            try {
                                eval(result['__trackingScript']);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                    }
                    errorAreas.map(setAttribute('hidden', 'hidden'));
                } else {
                    console.log("ERROR");
                    errorAreas.map(removeAttribute('hidden'));
                }
            })
            .catch(() => {
            });


    }
}

function scrollToTarget(target, offset) {
    let bodyRect = document.body.getBoundingClientRect().top;
    let elementRect = target.getBoundingClientRect().top;
    let elementPosition = elementRect - bodyRect;
    let offsetPosition = elementPosition - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}

function isValidationForm(form) {
    return matches('.js-form-validation', form);
}

